import { Card, Stack, Typography } from '@mui/material';
import { useMemo } from 'react';
import { Contributor, ProductMeta } from '../../types/DocumentTypes';
import { useTranslation } from 'react-i18next';

export default function BookDetails({
  productMeta,
}: Readonly<{
  productMeta: ProductMeta;
}>) {
  const { t } = useTranslation();
  const authorNames = useMemo(() => {
    if (!productMeta || !Array.isArray(productMeta.contributors)) {
      return '';
    }

    return productMeta.contributors
      .filter((c: Contributor) => c.role === 'Author')
      .map((c: Contributor) => c.name)
      .join(', ');
  }, [productMeta]);

  return (
    <Stack direction='row' spacing={3} alignItems='flex-start'>
      <Card sx={{ minWidth: '96px', width: '96px', height: 'auto' }}>
        <img
          src={productMeta.coverImageUrl}
          alt={`${t('readingView.bookDetails.coverImageAlt')} ${productMeta.title}`}
          style={{ display: 'block', width: '100%', height: 'auto' }}
        />
      </Card>
      <Stack direction='column' flexGrow={1} gap={0.5}>
        <Typography
          variant='h3'
          sx={{
            overflowWrap: 'break-word',
            wordBreak: 'break-word',
            lineHeight: 1.3,
          }}
          gutterBottom
        >
          {productMeta.title}
        </Typography>
        <Typography variant='caption'>{authorNames}</Typography>
        {productMeta.publicationYear && (
          <Typography variant='caption'>
            {productMeta.publicationYear}
          </Typography>
        )}
        <Typography variant='caption'>
          {t('readingView.bookDetails.isbn')} {productMeta.isbn}
        </Typography>
      </Stack>
    </Stack>
  );
}
